import React, {useEffect} from 'react'
import {Link} from 'react-router-dom'
import {KTSVG} from '../../../../_CarWash/helpers'
import {INewModelRequest} from '../../../models/vehicle-manage-model/INewModelRequest'

type Props = {
  data: INewModelRequest
  handleshowChange: (newModelRequestID: number, statusID: number) => void
  handleShow: (id: number) => void
}

const NewModelRequestCard: React.FC<Props> = ({data, handleshowChange, handleShow}) => {
  const pathUrl = process.env.REACT_APP_API_URL

  useEffect(() => {
    console.log('Use Effect Call')
    return () => {}
  }, [data])

  return (
    <>
      <tr key={data.vehicleMakeID} className='text-start'>
        <td>
          <span className='text-dark text-hover-primary d-block fs-6'>{data.customerName}</span>
        </td>
        <td>
          <span className='text-dark text-hover-primary d-block fs-6'>{data.mobileNumber}</span>
        </td>
        <td>
          <span className='text-dark text-hover-primary d-block fs-6'>{data.vehicleMakeName}</span>
        </td>
        <td>
          <span className='text-dark text-hover-primary d-block fs-6'>{data.vehicleModelName}</span>
        </td>

        <td>
          <span className='text-dark text-hover-primary d-block fs-6'>{data.noOfSeat}</span>
        </td>

        <td>
          <span
            className={
              data.statusID == 1
                ? 'text-success text-hover-primary ms-0 d-block fs-6 badge badge-light cursor-pointer'
                : 'text-dark text-hover-primary ms-0 d-block fs-6 badge badge-light-danger cursor-pointer'
            }
            onClick={() => handleshowChange(data.newModelRequestID, data.statusID)}
          >
            {data.statusID == 1 ? 'Open' : data.statusID == 2 ? 'Close' : ''}
          </span>
        </td>

        <td>
          <div className='d-flex justify-content-end flex-shrink-0'>
            <Link
              to={`/vehicle/new-model-request/edit/${data.newModelRequestID}`}
              className='btn btn-icon btn-bg-light bg-hover-primary text-hover-inverse-primary btn-sm me-1'
            >
              <KTSVG
                path='/media/icons/duotune/art/art005.svg'
                className='svg-icon-3 svg-icon-primary'
              />
            </Link>
            <div
              onClick={() => handleShow(data.newModelRequestID)}
              className='btn btn-icon btn-bg-light bg-hover-danger text-hover-inverse-danger  btn-sm'
            >
              <KTSVG
                path='/media/icons/duotune/general/gen027.svg'
                className='svg-icon-3 svg-icon-danger'
              />
            </div>
          </div>
        </td>
      </tr>
    </>
  )
}

export {NewModelRequestCard}
